export class MathHelper {
  static maxItem<T>(items: T[], compare: (a: T, b: T) => number): T {
    if (!items || items.length === 0) {
      return null;
    }

    let max = items[0];
    for (let i = 1; i < items.length; i++) {
      if (compare(max, items[i]) < 0) {
        max = items[i];
      }
    }

    return max;
  }

  static max(items: number[]) {
    if (!items || items.length === 0) {
      return null;
    }

    let max = items[0];
    for (let i = 1; i < items.length; i++) {
      if (items[i] > max) {
        max = items[i];
      }
    }

    return max;
  }

  static sum(items: number[]): number {
    let i = 0;
    items.forEach(m => i += m);
    return i;
  }

  static iterate(count: number): number[] {
    const items = [];

    for (let i = 0; i < count; i++) {
      items.push(i);
    }

    return items;
  }
}
